import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserExpectationSectionComponent } from './components/user-expectation-section/user-expectation-section.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [UserExpectationSectionComponent],
  imports: [
    CommonModule,
    MatButtonModule
  ],
  exports: [UserExpectationSectionComponent]
})
export class UserExpectationSectionModule { }
